import { ThemeProvider } from './contexts/ThemeContext';
import { MoodAtmosphere } from './components/MoodAtmosphere';
import Nav from './components/Nav';
import Landing from './components/Landing';
import Footer from './components/Footer';

/* One page for now. Routing comes back when there is a second page to route to —
   a nav item that goes nowhere is worse than no nav item.
   MoodAtmosphere mounts before Nav so its fixed layers sit under everything
   the page renders (it manages its own negative z-index). */
function App() {
  return (
    <ThemeProvider>
      <MoodAtmosphere />
      <Nav />
      <main>
        <Landing />
      </main>
      <Footer />
    </ThemeProvider>
  );
}

export default App;
